module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page-player__container c-page--container c-marg--before-footer u-relative u-pad-y-1"
  }, [_c('div', {
    staticClass: "u-align-center u-pad-y-1"
  }, [_c('app-img', {
    staticClass: "u-inline-block u-valign-middle u-marg-b-lg u-marg-t-xxxl",
    attrs: {
      "src": _vm.contentPage.team.logo,
      "width": "85",
      "alt": _vm.contentPage.team.name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-marg-b-xxxl u-marg-b-md@md u-align-center"
  }, [_c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--center"
  }, [_c('div', [_c('strong', {
    staticClass: "t-text--xl u-block u-color--gray-light u-break-word",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.name)
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "c-teams--name u-block t-h u-bold u-uppercase u-marg-b-md t-text--xxl@md u-break-word",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.nickname)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-team-profile__social-links-container u-marg-b-lg u-marg-b-0@md u-flex u-flex-fd--column@md u-flex-ai--center u-flex-jc--space-between u-pad-y-md"
  }, [_c('router-link', {
    staticClass: "c-team-profile__prev-team-container u-flex u-hide@md u-flex-jc--start u-w1of6 u-pad-y-xxs u-cursor-pointer u-color--red",
    attrs: {
      "to": _vm._getPlayerUrlFromIndex(_vm.activePlayerIndex - 1)
    }
  }, [(_vm.activePlayerIndex > 0) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center u-flex-ai--center u-uppercase t-text--xs t-text--bold"
  }, [_c('svg', {
    staticClass: "c-team-profile__arrow--prev u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-team-profile__prev-team u-absolute u-index--1"
  }, [_vm._v("Previous player")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "u-flex u-flex-fd--column@md u-flex-jc--center"
  }, [(_vm.contentPage.player.observeId !== false) ? _c('app-btn', {
    staticClass: "u-marg-r-sm u-valign-middle u-marg-r-0@md u-marg-b-xxs@md",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--support.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.support)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-valign-middle u-bold"
  }, [_vm._v("(" + _vm._s(_vm.contentPage.player.observeCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-block@md"
  }, [(_vm.contentPage.social.facebook) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.facebook,
      "type": "facebook"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.twitter) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.twitter,
      "type": "twitter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.youtube) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.youtube,
      "type": "youtube"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.link) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.link,
      "type": "link"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "c-team-profile__next-team-container u-flex u-hide@md u-flex-jc--end u-flex-ai--center u-w1of6 u-pad-y-xxs u-cursor-pointer u-color--red",
    attrs: {
      "to": _vm._getPlayerUrlFromIndex(_vm.activePlayerIndex + 1)
    }
  }, [(_vm.activePlayerIndex < _vm.teamAllPlayers.length - 1) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-ai--center u-uppercase t-text--xs t-text--bold"
  }, [_c('span', {
    staticClass: "c-team-profile__next-team u-absolute u-index--1"
  }, [_vm._v("Next player")]), _vm._v(" "), _c('svg', {
    staticClass: "c-team-profile__arrow--next u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-team-profile__social-links-container__bottom u-marg-t-md u-pad-y-md u-hide u-flex-jc--space-between u-flex-ai--center u-fit-w"
  }, [_c('router-link', {
    staticClass: "c-team-profile__prev-team-container u-flex u-flex-jc--start u-w1of2 u-pad-y-xxs u-cursor-pointer u-color--red",
    attrs: {
      "to": _vm._getPlayerUrlFromIndex(_vm.activePlayerIndex - 1)
    }
  }, [(_vm.activePlayerIndex > 0) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center u-flex-ai--center u-uppercase t-text--xs t-text--bold"
  }, [_c('svg', {
    staticClass: "c-team-profile__arrow--prev u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-team-profile__prev-team u-absolute u-index--1"
  }, [_vm._v("Previous player")])]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "c-team-profile__next-team-container u-flex u-flex-jc--end u-flex-ai--center u-w1of2 u-pad-y-xxs u-cursor-pointer u-color--red",
    attrs: {
      "to": _vm._getPlayerUrlFromIndex(_vm.activePlayerIndex + 1)
    }
  }, [(_vm.activePlayerIndex < _vm.teamAllPlayers.length - 1) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-ai--center u-uppercase t-text--xs t-text--bold"
  }, [_c('span', {
    staticClass: "c-team-profile__next-team u-absolute u-index--1"
  }, [_vm._v("Next player")]), _vm._v(" "), _c('svg', {
    staticClass: "c-team-profile__arrow--next u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })])]) : _vm._e()])], 1)], 1), _vm._v(" "), (_vm.contentPage.player.description) ? _c('p', {
    staticClass: "t-text--md t-lspacing--sm u-line-height--md u-color--gray-light u-marg-b-md u-align-left u-marg-x-auto u-w2of3@xl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.description)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-x-auto u-align-center u-vacuum u-marg-b-xxl u-w2of3@xl"
  }, [(_vm.contentPage.player && _vm.contentPage.player.age && _vm.contentPage.player.age.label && _vm.getYears(_vm.contentPage.player.age.birthdate) > 0) ? _c('div', {
    staticClass: "u-inline-block u-w1of3 u-valign-top"
  }, [_c('span', {
    staticClass: "t-text--sm u-marg-b-xs u-color--white u-uppercase u-block",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.age.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-stat-name t-lspacing--sm u-color--gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.getYears(_vm.contentPage.player.age.birthdate))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.contentPage.player && _vm.contentPage.player.country && _vm.contentPage.player.country.label) ? _c('div', {
    staticClass: "u-inline-block u-w1of3 u-valign-top"
  }, [_c('span', {
    staticClass: "t-text--sm u-marg-b-xs t-lspacing--sm u-color--white u-uppercase u-align-center u-block u-marg-b-xxxs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.country.label)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": '/static/team/icon-flag-' + _vm.contentPage.player.country.acronym.toLowerCase() + '.png',
      "alt": _vm.contentPage.player.country.name,
      "width": "70",
      "height": "47"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.contentPage.player && _vm.contentPage.player.mainStat && _vm.contentPage.player.mainStat.label) ? _c('div', {
    staticClass: "u-inline-block u-w1of3 u-valign-top"
  }, [_c('span', {
    staticClass: "t-text--sm u-marg-b-xs u-color--white u-uppercase u-block",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.mainStat.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-stat-name t-lspacing--sm u-color--gray-text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.mainStat.value)
    }
  }), (_vm.contentPage.player.mainStat.unit) ? _c('sup', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.player.mainStat.unit)
    }
  }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.contentPage.player.stats.length > 0) ? _c('div', {
    staticClass: "u-marg-x-auto u-align-center u-vacuum u-marg-b-md u-w2of3@xl"
  }, [_c('div', {
    staticClass: "c-team-profile__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-player__bg-gradiant u-align-center"
  }, [_c('img', {
    staticClass: "u-marg-t-xxl u-marg-b-xxl",
    attrs: {
      "src": _vm.contentGlobal.videoGamesAll.find(function (game) { return parseInt(game.id, 10) === _vm.currentGameId; }).logo_light,
      "width": "262"
    }
  })]), _vm._v(" "), _vm._l((_vm.contentPage.player.stats), function(stat) {
    return (stat.value != '') ? _c('div', {
      staticClass: "u-inline-block u-w1of3 u-vlu-valign-top u-marg-b-xxl"
    }, [_c('span', {
      staticClass: "t-text--sm u-marg-b-xs u-color--white u-uppercase u-block",
      domProps: {
        "innerHTML": _vm._s(stat.label)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "c-stat-name t-lspacing--sm u-color--gray-text"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(stat.value)
      }
    }), (stat.unit) ? _c('sup', {
      domProps: {
        "innerHTML": _vm._s(stat.unit)
      }
    }) : _vm._e()])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.interview.length > 0) ? _c('div', [_c('div', {
    staticClass: "c-team-profile__hr"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "c-player__interview-container u-marg-x-auto u-marg-t-xxl u-w2of3 u-w9of10@md"
  }, _vm._l((_vm.interview), function(item, index) {
    return _c('div', {
      staticClass: "c-player__interview-container__item u-marg-t-lg u-marg-t-xl@sm u-flex",
      class: [index % 2 === 0 ? 'is-left' : 'is-right']
    }, [_c('div', {
      staticClass: "u-w1of2 u-fit-w@sm"
    }, [_c('div', {
      staticClass: "u-relative"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "c-player__interview-container__item__question u-color--gray-dark u-line-height--md",
      domProps: {
        "innerHTML": _vm._s(item.question)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-player__interview-container__item__answer u-marg-t-xxxs u-line-height--md",
      domProps: {
        "innerHTML": _vm._s(item.answer)
      }
    })])])
  }))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-player__bg-gradiant u-align-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/player/player-interview-icon.png",
      "alt": "",
      "width": "236px",
      "height": "244px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--center"
  }, [_c('span', {
    staticClass: "u-color--red-pure u-uppercase t-text--bold t-text--xxl t-lspacing--sm u-align-center"
  }, [_vm._v("Player Interview")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-player__interview-container__item__icon-container u-absolute"
  }, [_c('img', {
    staticClass: "u-fit-w",
    attrs: {
      "src": "/static/shape/shape-hexagon-filled--red.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f10d9dc"}!./src/scripts/components/page-player/template.html
// module id = 938
// module chunks = 0